<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      size="small"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_subgroup_name') || '产线人员小组名称'"
            prop="subgroupName"
          >
            <el-input
              v-model="formData.subgroupName"
              :placeholder="
                $l('pls_input_subgroup_name') || '请输入产线人员小组名称'
              "
              :maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_is_last') || '是否末级'"
            prop="isLast"
          >
            <el-radio-group v-model="formData.isLast">
              <el-radio border label="Y">{{
                $l("form_label_is_last_Y") || "是"
              }}</el-radio>
              <el-radio border label="N">{{
                $l("form_label_is_last_N") || "否"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      :visible.sync="backDialogVisible"
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      width="30%"
      append-to-body
      draggable
    >
      <span>{{ $l("INDEX.tips_question_save") || "是否要保存更改？" }}</span>
      <template #footer>
        <el-button size="small" @click="backDialogVisible = false">
          {{ $l("INDEX.btn_cancel") || "取消" }}
        </el-button>
        <el-button size="small" @click="close">
          {{ $l("INDEX.btn_no_save") || "不保存" }}
        </el-button>
        <el-button size="small" type="primary" @click="save">
          {{ $l("INDEX.btn_save") || "保存" }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from "@/mixins/edit-loading";
import validate from "@/libs/util.validate";

export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    type: { type: String, default: "" },
    subgroupCode: { type: String, default: "" },
    levelNo: { type: Number, default: 1 },
  },
  data() {
    return {
      formData: {
        subgroupName: "",
        parentCode: this.subgroupCode,
        levelNo: this.levelNo + 1,
      },
      rules: {
        subgroupName: [
          {
            required: true,
            trigger: "blur",
            message:
              this.$l("rule_input_subgroup_name") || "请输入产线人员小组名称",
          },
        ],
        isLast: [
          {
            required: true,
            trigger: "change",
            message: this.$l("rule_select_is_last") || "请选择是否末级",
          },
        ],
      },
      backDialogVisible: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      if (!this.subgroupCode || this.type === "add") return;

      const res = await this.$api
        .factoryMrpSubgroupDetailApi({ subgroupCode: this.subgroupCode })
        .catch(() => null);
      if (!res) return;
      this.formData = res.body;
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) {
        this.backDialogVisible = false;
        return;
      }

      if (this.loadingOpen()) return;
      const res = await this.$api
        .factoryMrpSubgroupSaveApi(this.formData)
        .catch(() => null);
      this.loadingClose();
      if (!res) return;

      const { status, msg } = res;
      const isWarning = status !== 200;
      this.$message({
        showClose: true,
        message: msg,
        type: isWarning ? "warning" : "success",
      });
      if (isWarning) return;

      this.close();
      this.$emit("reload");
    },
    cancel() {
      if (this.disabled) {
        this.close();
      } else {
        this.backDialogVisible = true;
      }
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>
